import React, { useEffect, useState } from "react";
import { Button,Form,Icon,Grid } from "tabler-react";
import Select from "react-select";
import { GetRoles } from "../../herramientas/JWT";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import { CanalesList } from '../Canales';
const  DispositivosForm =({ catalogo, accion, elemento })=> {
  const [crudbutonEnable, setCrudbutonEnable]= useState(true);
  const [proveedores, setProveedores]= useState([]);
  const [proveedor, setProveedor]= useState({ value: 0, label: "Seleciona una opción", data: null });
  const [formulario, setFormulario]= useState(
    {
      "identificador": "",
      "nombre": "",
      "proveedor": {},
      "grupo": "",
      "fechaActualizacion": new Date().getTime()
    }
  );
  const [tab, setTab]= useState(1);
  useEffect(()=>{
    Crud_Catalogos("proveedores", "get", "", "").then((returnVal) => {
      let provTemp= [];
      returnVal.map((p, index)=> provTemp.push({ value: p.id, label: p.nombre, data:p }) );
      setProveedores(provTemp);
    }).catch(err =>{ alert("A ocurrido un error")});
    if( accion !== 'nuevo' ){
      setFormulario({...elemento});
      setProveedor({ value: elemento.proveedor.id, label: elemento.proveedor.nombre, data: elemento.proveedor });
    }
  }, []);

  const enableSave =() =>{
    if( formulario.nombre.length
        && formulario.identificador.length
        && formulario.proveedor.id
        && formulario.grupo.length
      )
      return false;
    else
      return true
  }

  const borrar =()=> {
    setCrudbutonEnable(false);
    Crud_Catalogos(catalogo, "delete", "", formulario.id).then((returnVal) => {
      window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  const save=(metodo= "post")=> {
    setCrudbutonEnable(false);
    Crud_Catalogos(catalogo, metodo, formulario, "").then((returnVal) => {
    window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  return (
    <div>
      { accion === "modificar" ? <h1> { elemento.nombre } </h1> : null }
      <ul className="nav nav-tabs">
          <li className="nav-item">
            <a className={"nav-link"+ (tab === 1 ? " active":"")} onClick={()=> setTab(1)}>Dispositivo</a>
          </li>
          <li className="nav-item">
            <a className={"nav-link"+ (tab === 2 ? " active":"")} onClick={()=> setTab(2)} hidden={accion === "nuevo"} > Canales</a>
          </li>
        </ul>
        <div  hidden={tab !== 1}>
          <Grid.Row>
            <Grid.Col md={12} xl={12}>
              <Grid.Row>
                <Grid.Col md={9} lg={9}>
                  <Form.Group label="Nombre">
                    <Form.Input name="nombre" type="text" value={ formulario.nombre }
                      onChange={ (e)=> setFormulario({...formulario, nombre: e.target.value }) }
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col md={6} lg={6}>
                  <Form.Group label="Identificador">
                    <Form.Textarea name="ident" type="text" value={ formulario.identificador } 
                      onChange={ (e)=> setFormulario({...formulario, identificador: e.target.value }) }
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col md={6} lg={6}>
                  <Form.Group label="Proveedor">
                    <Select value={proveedor}
                      onChange={
                        (e)=>{
                          setFormulario({...formulario, proveedor: e.data });
                          setProveedor(e);
                        }}
                      options={proveedores} />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col md={6} lg={6}>
                  <Form.Group label="Grupo">
                    <Form.Textarea name="grupo" type="text" value={ formulario.grupo } 
                      onChange={ (e)=> setFormulario({...formulario, grupo: e.target.value }) } />
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
            </Grid.Col>
          </Grid.Row>
          <div className="float-right">
            {GetRoles().includes("root") ?
              <span class="badge">
                  <Button target="_blank" size="sm" RootComponent="a" color="primary" disabled= { enableSave() || !crudbutonEnable }
                    onClick= { accion === "modificar" ? () => save("put") : () => save("post") }
                  >
                    <span class="badge"><Icon link={true} name="save" />Guardar</span>
                  </Button>
              </span>
            :null}
            { GetRoles().includes("root")  ?
              <span class="badge">
                <Button target="_blank" size="sm" RootComponent="a" color="primary"
                  onClick= { () => borrar() } disabled={!crudbutonEnable || !formulario.id}
                >
                  <span class="badge"><Icon link={true} name="trash" />Borrar</span>
                </Button>
              </span>
            :
            null
            }
          </div>
        </div>
        <div  hidden={tab !== 2}>
        { accion !== 'nuevo' && <CanalesList dispositivo={ elemento } /> }
        </div>
    </div>
  );
}
export default DispositivosForm;
